/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Progress information for a supplement workflow
 * @export
 * @interface SupplementWorkflowProgress
 */
export interface SupplementWorkflowProgress {
    /**
     * ID of the supplement being processed
     * @type {number}
     * @memberof SupplementWorkflowProgress
     */
    supplementId: number;
    /**
     * Overall workflow status
     * @type {string}
     * @memberof SupplementWorkflowProgress
     */
    status: SupplementWorkflowProgressStatusEnum;
    /**
     * Progress percentage (0.0 to 1.0)
     * @type {number}
     * @memberof SupplementWorkflowProgress
     */
    progress: number;
    /**
     * Current stage of the workflow
     * @type {string}
     * @memberof SupplementWorkflowProgress
     */
    stage: string;
    /**
     * Current status message
     * @type {string}
     * @memberof SupplementWorkflowProgress
     */
    message?: string | null;
    /**
     * Error message if workflow failed
     * @type {string}
     * @memberof SupplementWorkflowProgress
     */
    error?: string | null;
    /**
     * Array of reasoning chunks from AI analysis
     * @type {Array<string>}
     * @memberof SupplementWorkflowProgress
     */
    reasoningLog?: Array<string> | null;
    /**
     * When the progress was last updated
     * @type {Date}
     * @memberof SupplementWorkflowProgress
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const SupplementWorkflowProgressStatusEnum = {
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type SupplementWorkflowProgressStatusEnum = typeof SupplementWorkflowProgressStatusEnum[keyof typeof SupplementWorkflowProgressStatusEnum];


/**
 * Check if a given object implements the SupplementWorkflowProgress interface.
 */
export function instanceOfSupplementWorkflowProgress(value: object): value is SupplementWorkflowProgress {
    if (!('supplementId' in value) || value['supplementId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupplementWorkflowProgressFromJSON(json: any): SupplementWorkflowProgress {
    return SupplementWorkflowProgressFromJSONTyped(json, false);
}

export function SupplementWorkflowProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementWorkflowProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'supplementId': json['supplementId'],
        'status': json['status'],
        'progress': json['progress'],
        'stage': json['stage'],
        'message': json['message'] == null ? undefined : json['message'],
        'error': json['error'] == null ? undefined : json['error'],
        'reasoningLog': json['reasoningLog'] == null ? undefined : json['reasoningLog'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SupplementWorkflowProgressToJSON(json: any): SupplementWorkflowProgress {
    return SupplementWorkflowProgressToJSONTyped(json, false);
}

export function SupplementWorkflowProgressToJSONTyped(value?: SupplementWorkflowProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supplementId': value['supplementId'],
        'status': value['status'],
        'progress': value['progress'],
        'stage': value['stage'],
        'message': value['message'],
        'error': value['error'],
        'reasoningLog': value['reasoningLog'],
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

